import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Loader = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem("mx_loaded"));
  useEffect(() => {
    if (!show) return undefined;
    const t = setTimeout(() => { setShow(false); sessionStorage.setItem("mx_loaded", "1"); }, 2700);
    return () => clearTimeout(t);
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] bg-midnight flex flex-col items-center justify-center"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          initial={{ clipPath: "inset(0 0 0% 0)" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="relative font-display text-5xl sm:text-7xl tracking-[0.16em] leading-none">
            <span className="text-ivory/15">MEVALUX</span>
            <span className="loader-fill absolute inset-0">MEVA<span className="loader-gold">LUX</span></span>
          </div>
          <motion.span
            initial={{ opacity: 0, letterSpacing: "1.2em" }}
            animate={{ opacity: 1, letterSpacing: "0.7em" }}
            transition={{ delay: 0.6, duration: 1.4 }}
            className="mt-4 pl-[0.7em] font-sans font-light text-[11px] text-ivory/70"
          >
            PROPERTY
          </motion.span>
          <div className="mt-10 h-px w-40 bg-ivory/10 overflow-hidden">
            <div className="loader-line h-full bg-gold" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
